<template>
  <div class="columns is-multiline">
    <section class="info-tiles column is-12">
      <div class="card">
        <div class="card-header">
        </div>
        <div class="card-content">
          <h3 class="is-size-3">Cuentas <a class="button is-success is-radiusless" @click="goTo('account/new')"> + </a></h3>
          <b-field class="is-12" type="is-success" >
            <b-input placeholder="Criterio de búsqueda..." type="search" icon="magnify" v-model="fil" rounded></b-input>
            <p class="control">
                <button class="button is-success" @click="filter()">Buscar</button>
            </p>
          </b-field>
          <b-table :data="table.data" :striped="true" :hoverable="true" :paginated="true" :per-page="8">
              <template slot-scope="props">
                <b-table-column field="cuentas" label="Cuentas" sortable>
                    {{ props.row.account }}
                </b-table-column>
                <b-table-column field="municipio" label="Municipio" sortable>
                    {{ props.row.municipality }}
                </b-table-column>
                <b-table-column field="descripcion" label="Descripción" sortable>
                    {{ props.row.description }}
                </b-table-column>
                <b-table-column field="actions" label="Acciones" sortable>
                  <a class="button is-warning is-radiusless" @click="goTo('account/' + props.row.id)">
                    <font-awesome-icon :icon="['far','edit']"/></a>
                  <a class="button is-danger is-radiusless" @click="deleteq(props.row.id)">
                    <font-awesome-icon :icon="['fa','times']"/></a>
                </b-table-column>
              </template>
            </b-table>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import AccountsService from '@/services/AccountsService'
import { xMisc } from '@/mixins/xMisc.js'
import { sGate } from '@/mixins/sGate.js'
export default {
  name: 'dashboard',
  mixins: [xMisc, sGate],
  components: {
  },
  data () {
    return {
      fil: '',
      table: {
        data: []
      }
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      var accounts = await AccountsService.fetchAccounts(this.$session.get('user').token)
      for (var i = 0; i < accounts.data.length; i++) {
        this.table.data.push(accounts.data[i])
      }
    },
    async filter () {
      this.table.data = []

      var param = null

      if (this.fil !== '') {
        param = this.fil
      }
      var accounts = await AccountsService.filter(param, this.$session.get('user').token)
      for (var i = 0; i < accounts.data.length; i++) {
        this.table.data.push(accounts.data[i])
      }
    },
    async deleteData (id) {
      var account = await AccountsService.delAccount({id: id}, this.$session.get('user').token)
      if (account.data.success) {
        this.$toast.open({
          message: 'Cuenta Eliminada',
          type: 'is-success'
        })
        // unset data
        var s = this.table.data.length
        for (var i = s - 1; i >= 0; i--) {
          if (this.table.data[i].id === id) {
            this.table.data.splice(i, 1)
          }
        }
      } else {
        this.alert('danger', 'Error, Intente nuevamente')
      }
    },
    deleteq (id) {
      this.$dialog.confirm({
        title: 'Eliminando Cuenta',
        message: 'Estas seguro que quieres <b>eliminar</b> esta cuenta?',
        confirmText: 'Eliminar Cuenta',
        cancelText: 'Cancelar',
        type: 'is-danger',
        onConfirm: () => this.deleteData(id)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/account/Accounts.vue